<template>
  <div>
    <p class="grey-title">Оценка клиента</p>
    <textarea
      class="comment"
      placeholder="Комментарий"
      v-model="feedback.comment"
      @blur="addRating(feedback.rating)"
      >
    </textarea>

    <div class="smile-block">
      <p data-rating="veryBad"
        v-on:click="addRating($event.target.parentNode.getAttribute('data-rating'))"
        v-bind:class="{ active: feedback.rating === 'veryBad' }">
        <img class="colored" src="@/img/smile5.1.svg" alt="" />
        <img src="@/img/smile5.0.svg" alt="" />
      </p>

      <p data-rating="normal"
        v-on:click="addRating($event.target.parentNode.getAttribute('data-rating'))"
        v-bind:class="{ active: feedback.rating === 'normal' }" >
        <img class="colored" src="@/img/smile3.1.svg" alt="" />
        <img src="@/img/smile3.0.svg" alt="" />
      </p>

      <p data-rating="veryGood"
        v-on:click="addRating($event.target.parentNode.getAttribute('data-rating'))" 
        v-bind:class="{ active: feedback.rating === 'veryGood' }" >
        <img class="colored" src="@/img/smile1.1.svg" alt="" />
        <img src="@/img/smile1.0.svg" alt="" />
      </p>

    </div>
  </div>
</template>
<script>
  export default {
    props: ['element', 'productInfo'],
    data: () => ({
      feedback: {
        rating: '',
        comment: '',
        productId: ''
      }
    }),
    methods: {
      addRating(rating){
        this.feedback.rating = rating;
        let miniCart = this.$localStorageGet('miniCart'); //Миникорзина с localStorage
        let productId = 'productId_' + this.element;


        if(Object.keys(miniCart).length == 0){ //Если миникорзина пустая
        
          
          miniCart[productId] = []; //Добавить текущий товар
          miniCart[productId].push(this.feedback); //Добавить отзыв в текущий товар
          this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
        }else{ //Если миникорзина не пустая
          if(miniCart[productId]){  //Если в миникорзине уже есть такой товар
              // let ratingItem = miniCart[productId].find(x => x['rating']); //найти поле с рейтингом
              let ratingItem = miniCart[productId].find(x => x.hasOwnProperty('rating')); //найти поле с рейтингом
              if(ratingItem != undefined){ //Если рейтинг уже был выставлен
                ratingItem.rating = this.feedback.rating  //Обновить данные
                ratingItem.comment = this.feedback.comment  //Обновить данные
                this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
              }else{
                miniCart[productId].push(this.feedback) //Если рейтинге еще нет, добавить
                this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
              }
          }else{
              miniCart[productId] = []; //Добавить текущий товар
              miniCart[productId].push(this.feedback); //Добавить отзыв в текущий товар
              this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
          }

          // for(var key in miniCart){ 
    
          //   if(productId == key){ //Если в миникорзине уже есть такой товар
              
          //     let ratingItem = miniCart[key].find(x => x['rating']); //найти поле с рейтингом
          //     let commentItem = miniCart[key].find(x => x['comment']); //найти поле с комментом

          //     if(ratingItem){ //Если рейтинг уже был выставлен
        
          //       ratingItem.rating = this.feedback.rating  //Обновить данные
          //       ratingItem.comment = this.feedback.comment  //Обновить данные
          //       this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
                
          //     }else{
                
          //       miniCart[key].push(this.feedback) //Если рейтинге еще нет, добавить
          //       this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
                
          //     }
          //   }else{
              
          //     miniCart[productId] = []; //Добавить текущий товар
          //     miniCart[productId].push(this.feedback); //Добавить отзыв в текущий товар
          //     this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
          //   }
          // }


          this.$localStorageSet('miniCart', miniCart)//Закинуть миникорзину в localStorage
        }
        
      },
      init(){
        this.feedback.rating = '';
        this.feedback.comment = '';



        this.feedback.productId = this.element;
        let miniCart = this.$localStorageGet('miniCart');
        if(Object.keys(miniCart).length == 0){
          this.feedback.rating = '';
          this.feedback.comment = '';
        }else{
          for(var key in miniCart){
            if('productId_'+this.element == key){
              let ratingItem = miniCart[key].find(x => x['rating'] || x['comment']);
              if(ratingItem){
                this.feedback.rating = ratingItem.rating;
                this.feedback.comment = ratingItem.comment;
              }else{
                this.feedback.rating = '';
                this.feedback.comment = '';
              }
              return false
            }else{
              // this.feedback.rating = '';
              // this.feedback.comment = '';
            }
          }
        }
      }
    },
    watch: {
      productInfo(){
        this.init();
      } 
    }
    
  }
</script>